import { render, staticRenderFns } from "./OrderIconsField.vue?vue&type=template&id=d71822d0"
import script from "./OrderIconsField.vue?vue&type=script&lang=js"
export * from "./OrderIconsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports